module.exports = __webpack_public_path__ + "img/directions_boat_outlined.424ae55e.svg";